export function ProductPrice({ price, mrp, size = "md", className = "", showDiscount = false }) {
  const hasDiscount = mrp && mrp > price;
  const discountPct = hasDiscount ? Math.round(((mrp - price) / mrp) * 100) : 0;
  const sizes = {
    sm: { current: "text-sm font-semibold", mrp: "text-xs", pct: "text-[10px]" },
    md: { current: "text-base font-semibold", mrp: "text-sm", pct: "text-xs" },
    lg: { current: "text-xl font-bold", mrp: "text-base", pct: "text-sm" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex flex-wrap items-baseline gap-x-2 gap-y-0.5 ${className}`}>
      <span className={`text-slate-900 ${s.current}`}>₹{price}</span>
      {hasDiscount && (
        <span className={`text-slate-400 line-through ${s.mrp}`}>₹{mrp}</span>
      )}
      {hasDiscount && showDiscount && discountPct > 0 && (
        <span className={`font-bold uppercase tracking-wider text-emerald-600 ${s.pct}`}>
          {discountPct}% OFF
        </span>
      )}
    </div>
  );
}
